module.exports = __webpack_public_path__ + "img/1-1-1.9eb1bf05.png";